
<template>
  <!-- <div class="editable" contenteditable="true" v-once @input="update"> -->
  <div class="editable" contenteditable="true" @keydown.enter="update" @blur="update">
    {{content}}
  </div>
</template>

<script>

export default {
  name: 'BlurEditableEnter',
  props: ['content'],
  methods: {
    update (event) {
      this.$emit('update', event.target.innerText)
      this.$emit('change', event.target.innerText)
    }
  }
}
</script>

<style>

  .editable {
    display: inline;
  }

</style>



// WEBPACK FOOTER //
// src/components/BlurEditableEnter.vue